import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { plainToClass } from 'class-transformer';

import { environment } from '../../../environments/environment';
import { CollectApiServiceBase } from './collect-api-base.service';
import { ProgressIndicatorService } from './progress-indicator.service';
import { MultiDropdownOptionsData, MultiDropdownSearchData } from '../models/multi-dropdown/imulti-dropdown-data-source';

@Injectable()
export class TypeAheadDropdownService extends CollectApiServiceBase<MultiDropdownOptionsData> {
    // Constructor.
    public constructor(http: HttpClient, progressIndicatorService: ProgressIndicatorService) {
        super(http, progressIndicatorService, environment.apiUrl, 'typeaheaddropdown', MultiDropdownOptionsData);
    }

    // Implement formatResponse -- this is required since we are presently inheriting from CollectApiServiceBase.
    public formatResponse(data: MultiDropdownOptionsData): MultiDropdownOptionsData {
        var obj = plainToClass(MultiDropdownOptionsData, data);

        return obj;
    }

    // Type-ahead search method.
    public getDropdownOptions(searchInfo: MultiDropdownSearchData): Promise<MultiDropdownOptionsData> {
        let url = `${this.url}/${this.endpoint}/getDropdownOptions/${searchInfo.searchTerm}`;

        return this.http.get<MultiDropdownOptionsData>(url)
            .toPromise()
            .then(dropdownOptionsData => {
                let result: MultiDropdownOptionsData = this.formatResponse(dropdownOptionsData);
                return result;
            })
            .catch(this.handleError);
    }
}
